<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>
<script>
export default {
  name: "app",
  data() {
    return {
      // options: [
      //   { value: 1, text: "AA" },
      //   { value: 2, text: "Bb" },
      //   { value: 3, text: 33 }
      // ]
    };
  },
  methods: {},
  created() {
    localStorage.removeItem("reloaded");
  }
};
</script>
<style lang="scss">
#app {
  background: #f9f9fb;
  height: 100%;
}
</style>
